<script>
  import TextStub from './TextStub.vue'

  export default {
    name: 'NonDataStub',
    props: {
      customClass: {
        type: String,
        default: ''
      },
      stubClass: {
        type: String,
        default: ''
      },
      captionText: {
        type: String,
        default: 'Данные отсутствуют'
      },
      stubData: {
        type: null,
        required: true
      }
    },
    render(h) {
      let component
      if (!this.stubData || !this.stubData.length) {
        component = h(TextStub, {
          props: {
            captionText: this.captionText
          },
          class: {
            [this.stubClass]: this.stubClass
          }
        })
      } else {
        component = h('div', {
          class: {
            [this.customClass]: this.customClass
          }
        }, this.$slots.default)
      }
      return component
    }
  }
</script>
